import { Loader2 } from 'lucide-react';
import { useProcessing } from '../context/ProcessingContext';

export function ProcessingOverlay() {
  const {
    isProcessing,
    processingMessage,
    hasError,
    resetProcessingState
  } = useProcessing();

  if (!isProcessing && !hasError) return null;

  return (
    <div className="fixed inset-0 bg-[rgb(var(--color-black-rgb)/0.5)] flex items-center justify-center z-50 p-4">
      <div className="bg-[--bg-primary] rounded-lg shadow-lg w-full max-w-[320px] overflow-hidden">
        {hasError ? (
          <div className="p-6">
            <div className="flex flex-col items-center">
              <p className="text-sm text-[--text-secondary] text-center min-h-[40px] flex items-center">
                {processingMessage === 'too-many-files'
                  ? 'Please upload only one file at a time.'
                  : processingMessage}
              </p>
              <button
                onClick={resetProcessingState}
                className="mt-4 px-4 py-2 bg-warning-500 text-[--text-inverse] text-sm rounded-md hover:bg-warning-600 transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        ) : (
          <div className="p-6">
            <div className="flex items-center space-x-4">
              <Loader2 className="w-6 h-6 text-primary-500 animate-spin flex-shrink-0" />
              <p className="text-sm text-[--text-secondary] min-h-[40px] flex items-center">
                {processingMessage || 'Processing...'}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}